module.exports = __webpack_public_path__ + "static/media/logo-ku.72565482.svg";